import { vehicleDispositionsV2Model } from './vehicle-dispositions-v2-model'

export const createVehicleDispositionV2Schema = vehicleDispositionsV2Model.pick({
  vehicleId: true,
  operatorId: true,
  reviewNotes: true,
  status: true
})
